import { Button, message } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import DynamicTable from "../../components/DynamicTable";

function VehiclesData() {
  const [vehicles, setVehicles] = useState({});

  useEffect(() => {
    fetchVehiclesData();
  }, []);

  const fetchVehiclesData = async () => {
    const res = await apiRequest({
      path: apiPaths.vehiclesData,
    });
    if (!res.error) {
      let vehiclesObj = res.results.reduce((vehicles, vehicle) => {
        vehicles[vehicle.vehicle_code + "v"] = vehicle;
        return vehicles;
      }, {});
      setVehicles(vehiclesObj);
    } else {
      message.error(res.error_description);
    }
  };

  const handleVehicleOnOFF = async (record) => {
    const res = await apiRequest({
      path:
        apiPaths.vehiclesData +
        `/${record.vehicle_code}/lock-status?lock=${!record.ignition}`,
      method: "PUT",
    });

    if (res.message !== "success") {
      message.error(res.message || res.error_description);
      return;
    }

    let vehiclesObj = { ...vehicles };
    vehiclesObj[record.vehicle_code + "v"].ignition = !record.ignition;
    setVehicles(vehiclesObj);
    message.success("Lock status updated");
  };

  const COLUMNS = [
    {
      title: "Vehicle Name",
      dataIndex: "vehicle.name",
      fixed: "left",
      width: 150,
      filterType: "search",
    },
    {
      title: "Ignition",
      dataIndex: "ignition",
      width: 100,
      render: (value, record) => (
        <div>
          <span style={{ color: value ? "green" : "red", marginRight: 10 }}>
            {value ? "ON" : "OFF"}
          </span>
          <Button
            onClick={() => handleVehicleOnOFF(record)}
            size="small"
            type="primary"
          >{`turn ${value ? "OFF" : "ON"}`}</Button>
        </div>
      ),
      // filterType: "search",
    },
    {
      title: "SoC",
      dataIndex: "battery_voltage",
      // filterType: "search",
      width: 150,
      render: (value, record) => {
        return (
          <div>
            <span style={{ color: record.soc < 15 ? "red" : "green" }}>
              {record.soc}
              {`% (${(value / 1000).toFixed(2)}v)`}
            </span>
          </div>
        );
      },
    },
    {
      title: "Range Left",
      dataIndex: "range_left",
      width: 100,
      render: (value) => value + " km",
    },
    {
      title: "Current Location",
      dataIndex: "latitude",
      // filterType: "search",
      width: "150px",
      render: (_, record) => {
        let value = record.latitude + "," + record.longitude;
        return (
          <div>
            <a href={`https://maps.google.com/?q=${value}`} target="_blank">
              {value}
            </a>
          </div>
        );
      },
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      width: "150px",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
      filterType: "date",
    },
    // {
    //   title: "Created Date",
    //   dataIndex: "created_date",
    //   width: "150px",
    //   render: (value) => {
    //     return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
    //   },
    //   filterType: "date",
    // },
  ];

  return (
    <div style={{ height: "80vh" }}>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(vehicles)}
          columns={COLUMNS}
          pagination={false}
          scroll={{ y: "65vh" }}
          showAction={false}
        />
      </div>
    </div>
  );
}

export default VehiclesData;
